import { BlockStack, Page, PageProps } from '@shopify/polaris';
import type { SpaceScale } from '@shopify/polaris-tokens';
import type { ResponsiveProp } from '@shopify/polaris/build/ts/src/utilities/css';
import useShopifyReviewAfterOrders from 'hooks/shopify-review-modal/useShopifyReviewAfterOrders';
import GlobalErrorBanner from 'layouts/error-banner/component/GlobalErrorBanner';
import Footer from 'layouts/mainframe/footer/Footer';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ContentPageWrapper = styled.div<{ $maxWidth: string }>`
    .Polaris-Header-Title__SubTitle.Polaris-Header-Title__SubtitleMaxWidth {
        max-width: unset !important;
    }
    .Polaris-Page {
        max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : 'unset')} !important;
    }
`;

const PagePickupBird: React.FC<PagePickupBirdProps & { children: React.ReactNode }> = ({
    bottom,
    children,
    hideFooter,
    maxWidth,
    hideErrorBanner,
    fullHeight,
    ...pageProps
}) => {
    const { t } = useTranslation();

    useShopifyReviewAfterOrders();

    return (
        <>
            <ContentPageWrapper $maxWidth={`${maxWidth}px`}>
                <Page {...pageProps}>
                    <div
                        className="flex flex-col justify-between"
                        style={{
                            paddingBottom: hideFooter ? '1.25rem' : undefined,
                            minHeight: fullHeight ? 'calc(100vh - 96px)' : undefined,
                        }}
                    >
                        <BlockStack gap={'400'}>
                            {!hideErrorBanner && <GlobalErrorBanner />}
                            {children}
                        </BlockStack>
                        {!hideFooter && <Footer />}
                    </div>
                </Page>
            </ContentPageWrapper>
        </>
    );
};

export default PagePickupBird;

interface PagePickupBirdProps extends PageProps {
    bottom?: ReactNode;
    gap?: ResponsiveProp<SpaceScale>;
    hideFooter?: boolean;
    maxWidth?: number;
    hideErrorBanner?: boolean;
    fullHeight?: boolean;
}
